<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
	<label for="file">Choose .csv file to open</label>
	<input #fileInput (change)="uploadCsvFile($event)" accept=".csv" id="file" type="file" />
	<a
		(click)="clearFile()"
		*ngIf="allLines.length > 0"
		style="text-decoration: underline !important; cursor: pointer; color: blue"
		>Clear</a
	>
</div>

<div class="m-t-2" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1rem">
	<a *ngIf="dataType == RFP_UPLOAD_TYPE" class="link" href="{{ S3_CSV_TEMPLATE.RFP_TEMPLATE }}">
		Download the file template.
	</a>
	<a *ngIf="dataType === 'load'" class="link" href="{{ S3_CSV_TEMPLATE.BULK_MATCH }}">
		Download the file template.
	</a>
	<a *ngIf="dataType == PROJECT_TYPE" class="link" href="{{ S3_CSV_TEMPLATE.BULK_PROJECTS }}">
		Download the file template.
	</a>
	<a *ngIf="dataType === 'broker'" class="link" href="{{ S3_CSV_TEMPLATE.BULK_BROKERS }}">
		Download the file template.
	</a>
</div>
